import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import loadPlugins from "./plugins";
import loadFilters from "./helpers/filters";
import moment from "moment";
import qz from "qz-tray";
import jsRsaSign from "jsrsasign";
import sha1 from "js-sha256";

/* plugins e filtros */

loadPlugins(Vue);
loadFilters(Vue);

/* moment em pt-br */

moment.locale("pt-br");

/* qz-tray */

const privateKey =
  "-----BEGIN PRIVATE KEY-----\n" +
  "MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQDAUBrfrt9RpjxM\n" +
  "2gYOQxuom6PlobscxG0Yvzt+n+S0RDsASjxhlgJdFzlaPynnD1FjFwn97YjCpVTu\n" +
  "JVNgFfMQm/BfGNiBul8O83KOGNhmqNV81hInO5D6h7519lRadrnZbRRgjlc+l3uk\n" +
  "NnKUxxstPoghar7lOLK2yNKsI7+GknB4Gzb9EI4bM0YkHhLDoVManIzALpK6LF0+\n" +
  "LPoZyraKRfBxInjODQCG0PnTk1PhnGLVoLAwFnrGTmt6mZiJUW1n9EAhCAYjQf7S\n" +
  "9ny9l92z3wlOPv9tW5XGUN+ha2NDpxxZrA9hZoyR/Mhy4kZ3+kNj9RKZN6amKi/r\n" +
  "CZjfpzl/AgMBAAECggEAF/KhthMPqho6ThOkR2hh7FgdS74dD9MCBt/hZ74/e5c3\n" +
  "hay44ioM90yqDqvo6uYEa4N18hH/QsXV0qYBQOja0MmqYB028Milh7YXIMzFPdtu\n" +
  "YlJCBnKrdhcrR4M6M92u/P1RWUjAYoH4mpVRJWe54aN0zjx9swuhbZOKcHcvJXGl\n" +
  "YG7Y2GacaFvco6fZJK7tLEqw88TNYShQmW+HPpkc4T3EcTNNpoWVcvgdhbELnMrb\n" +
  "F1yteIZq7N7YJkY4N4aeCSMgIi9I69QtKoXz0UvfjPjH2r6utnykA6y/LO5EYZTn\n" +
  "o7eMYShQMlP6kHDdm4fP2ZFyK+dKVBGWeTpET5hVuQKBgQDzv+lFHZfTmNEf0Lyx\n" +
  "mFshzPBilkzNOuJvZ0GOz9z9R3Xiir369G3MCdh8kR0YFf7JYviljXNz3dQwAAG7\n" +
  "J1WdlqFJUsV6meZIMCKdIGoFyJgNQ0aXtdcT1s5hOBq76xxSL9yOJD+poe+diWrv\n" +
  "aSwuJ/sqDdM0zk1ePsAZOY5muwKBgQDJ+mhMTRdFoWYKG+e87+wjNkaVznsw77FD\n" +
  "5EdW5Sk/GaL8xg80a+MGa+t0s7dogDjQvntYrJ2WCNNptm7hwEB11BxfwXLJbGbh\n" +
  "fr/5nF+JSFZ8cykLLIMEe3P5iy3rM3yaps8YEZ8solB09dfkNF8eshn5sTViZgc2\n" +
  "Z1jKJ2DmDQKBgAU9jgVXYolBEtXtRfFHhkYOwuhLtPEAoBenD6jDXUvwul8ZfoYj\n" +
  "tSya1ZWwBQEcj/LCdvgQN3g5P7OcfG0KpnOR5nvOFMLTBjltF4FrTfw72NEILj9a\n" +
  "wHoDt0It051Qq7Y0ozhHHTtHaQBpEOx+xV1krKi1zWGoQc+R581jCGW7AoGBALzF\n" +
  "sR0/H/UQOBJSqnBHvOfcHnR9G15NZ9wQSyzH2ZkEGPUvF57jBrhFvTbBkTW2QWO3\n" +
  "5AiorFBBx3YR7+hGiviVWj+Uyfe/vRgcIsjkgdYJKev+pemvnHRf/bDJiA0/fcH9\n" +
  "DaltLtvEiHYIH9NFr3E8/FIGceKZgTwzsySdUU8xAoGAQN8F5lP8ZJdzfdu9VfNg\n" +
  "EAA0kTsa2THBouVNM5pm3YB8hhyZklFneJemzZZ9YfKvzSrREFHE1A5QmiVJ8A/F\n" +
  "gFPYAeRO++loZzMKHJVE3lfdPVy21w0gFjLKOqbc7QUsnjSsjR/MsXvtuL1yOj3V\n" +
  "BihXwMrS1gh+laZzRc15Uy8=\n" +
  "-----END PRIVATE KEY-----";

const certificate =
  "-----BEGIN CERTIFICATE-----\n" +
  "MIIEGzCCAwOgAwIBAgIUYVypexlM0zUwRT39IwbzPesja58wDQYJKoZIhvcNAQEL\n" +
  "BQAwgZsxCzAJBgNVBAYTAkJSMREwDwYDVQQIDAhDZWFyw4PCoTESMBAGA1UEBwwJ\n" +
  "Rm9ydGFsZXphMRIwEAYDVQQKDAlTdXBlcm1lbnUxEjAQBgNVBAsMCVN1cGVybWVu\n" +
  "dTEbMBkGA1UEAwwSKi5zdXBlcm1lbnUuY29tLmJyMSAwHgYJKoZIhvcNAQkBFhFh\n" +
  "cHB6Mm1lQGdtYWlsLmNvbTAgFw0yMDAyMTgxNTE0MjdaGA8yMDUxMDgxMzE1MTQy\n" +
  "N1owgZsxCzAJBgNVBAYTAkJSMREwDwYDVQQIDAhDZWFyw4PCoTESMBAGA1UEBwwJ\n" +
  "Rm9ydGFsZXphMRIwEAYDVQQKDAlTdXBlcm1lbnUxEjAQBgNVBAsMCVN1cGVybWVu\n" +
  "dTEbMBkGA1UEAwwSKi5zdXBlcm1lbnUuY29tLmJyMSAwHgYJKoZIhvcNAQkBFhFh\n" +
  "cHB6Mm1lQGdtYWlsLmNvbTCCASIwDQYJKoZIhvcNAQEBBQADggEPADCCAQoCggEB\n" +
  "AMBQGt+u31GmPEzaBg5DG6ibo+WhuxzEbRi/O36f5LREOwBKPGGWAl0XOVo/KecP\n" +
  "UWMXCf3tiMKlVO4lU2AV8xCb8F8Y2IG6Xw7zco4Y2Gao1XzWEic7kPqHvnX2VFp2\n" +
  "udltFGCOVz6Xe6Q2cpTHGy0+iCFqvuU4srbI0qwjv4aScHgbNv0QjhszRiQeEsOh\n" +
  "UxqcjMAukrosXT4s+hnKtopF8HEieM4NAIbQ+dOTU+GcYtWgsDAWesZOa3qZmIlR\n" +
  "bWf0QCEIBiNB/tL2fL2X3bPfCU4+/21blcZQ36FrY0OnHFmsD2FmjJH8yHLiRnf6\n" +
  "Q2P1Epk3pqYqL+sJmN+nOX8CAwEAAaNTMFEwHQYDVR0OBBYEFHVoyaayXhRu6cfa\n" +
  "pHhjPpPPSX4KMB8GA1UdIwQYMBaAFHVoyaayXhRu6cfapHhjPpPPSX4KMA8GA1Ud\n" +
  "EwEB/wQFMAMBAf8wDQYJKoZIhvcNAQELBQADggEBAL4MBujBA7JCrsbReBmYZE9O\n" +
  "cbebdlaAFO6QpbzrtAqS0J555jqt8SIu+SSkmqT2jHX5PtNCBzRhQDnX/A+lQr+n\n" +
  "qASd8htMnb7HrvzH5DGZ6dEWr5+rqcFwFMjp+/gcZajT/ffLKQ2kMLQsODzGiJzA\n" +
  "zPlcJMbC8mdQymqLXYPqi39qN0qceA91Ltj/Fn12XEGmZe+EUphfQnxd7RxxvAVn\n" +
  "JZbs+sIsWrQPwMD18Lfwv3va2P0B/L2SmyW6SmLog56lYgjiDaretsoZPvQi0hND\n" +
  "QakIws6yEWiCL+mC2hxyDWTjzy573Rvqx0a6NxvBG7I2aHT+pfl3r2Ffr6h/O4E=\n" +
  "-----END CERTIFICATE-----";

qz.api.setPromiseType(function promise(resolver) {
  return new Promise(resolver);
});

qz.api.setWebSocketType(WebSocket);

qz.api.setSha256Type(function(data) {
  const hashed = sha1(data);
  return hashed;
});

qz.security.setSignaturePromise(function(toSign) {
  return (resolve, reject) => {
    try {
      const pk = jsRsaSign.KEYUTIL.getKey(privateKey);
      const sig = new jsRsaSign.KJUR.crypto.Signature({ alg: "SHA1withRSA" });
      sig.init(pk);
      sig.updateString(toSign);
      const hex = sig.sign();
      resolve(jsRsaSign.stob64(jsRsaSign.hextorstr(hex)));
    } catch (err) {
      console.error(err);
      reject(err);
    }
  };
});

qz.security.setCertificatePromise(resolve => resolve(certificate));

qz.websocket.connect();

/* vue */

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
